import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { jobQuery, runQuery } from '@/api/queries';
import { RunPage } from '@/features/runs/run-page';
import { isRunTab, type RunTab } from '@/features/runs/run-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un run de job, sous son projet. L'onglet actif vit dans l'URL (`?tab=files`). */
export const Route = createFileRoute('/$tenant/projects/$projectId/jobs/$jobId/runs/$runId')({
  validateSearch: (search: Record<string, unknown>): { tab: RunTab } => ({
    tab: isRunTab(search['tab']) ? search['tab'] : 'logs',
  }),
  component: RunRoute,
});

function RunRoute() {
  const { tenant, projectId, jobId, runId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  const job = useQuery(jobQuery(tenant, jobId));
  const run = useQuery(runQuery(tenant, jobId, runId));

  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="jobs"
      crumbs={[
        { label: t('nav.items.jobs') },
        { label: job.data?.name ?? jobId },
        { label: run.data?.name ?? runId, mono: true },
      ]}
    >
      <RunPage
        tenantId={tenant}
        projectId={projectId}
        jobId={jobId}
        runId={runId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
